@if (showHeader) {
  <div [ngClass]="getHeaderClass()">
    <div [ngClass]="getTitleClass()">
      <span id="spanTitle" class="w-100">
        {{ title | translate: titleParams }}
      </span>
    </div>
    @if (showMenu) {
      <div [ngClass]="getMenuClass()">
        <ng-content select="[slot=menu-body]"></ng-content>
      </div>
    }
  </div>
}
